var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M8.334 10.834a4.168 4.168 0 0 0 6.283.45l2.5-2.5a4.167 4.167 0 0 0-5.892-5.892L9.792 4.317m1.875 4.85a4.165 4.165 0 0 0-6.283-.45l-2.5 2.5a4.167 4.167 0 0 0 5.891 5.891l1.425-1.424"
  })));
};
export default SvgLink;